import { useAuthUserSignUpYclientsMutation, UtmMarkKeyTypeEnum } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import GraphQLApiUtils from '@shared/api/graphql/utils';

import { YClientsRegisterInputType, SpecialRegisterResultType, UseYClientsRegisterType } from './types';

const useYClientsRegister = (): UseYClientsRegisterType => {
  const [mutation, mutationResult] = useAuthUserSignUpYclientsMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const requestYClients = async (input: YClientsRegisterInputType) => {
    const result = await mutation({
      variables: {
        input: {
          ...input,
          utmMarks: [{ key: UtmMarkKeyTypeEnum.Yclients, value: input.userId }],
        },
      },
    });

    return !!result.data?.auth?.ok;
  };

  const signUpData = mutationResult.data?.auth;
  const hasErrors = !!signUpData?.errors;
  const registerResultData: SpecialRegisterResultType['data'] = { ok: signUpData?.ok };

  if (hasErrors) {
    registerResultData.errors = GraphQLApiUtils.errorsArrayToObject(signUpData?.errors);
  }

  const result: SpecialRegisterResultType = {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    data: registerResultData,
  };

  return [requestYClients, result];
};

export default useYClientsRegister;
